import type { FoundationsCourseState } from '@doneverse/shared'
import { api } from '../api/index.js'

export const foundationsService = {
  /**
   * The Founder Foundations course with the caller's progress already applied —
   * which lessons are unlocked, which are finished, and where to resume.
   *
   * Null when no course carries the Foundations designation yet (the API 404s),
   * so the page renders its "not available" state instead of throwing.
   */
  course: async (): Promise<FoundationsCourseState | null> => {
    return api
      .get('/v1/foundations')
      .notFound(() => null)
      .json<FoundationsCourseState>()
  },
}
